<template>
  <div>



    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>
    </b-row>
    <div>

      <b-card body-class="p-0" class="mt-1" >

        <div class="d-flex flex-wrap justify-content-center items-center"   v-if="loading">
          <b-spinner

              v-for="variant in variants"
              :key="variant"
              :variant="variant"
              class="mr-1"
              type="grow"
          />
        </div>
        <vue-good-table
            v-else
            :columns="columns"
            :rows="booking"
            :search-options="{
            enabled: true
          }"
            :pagination-options="{
              enabled: true,
              perPage:pageLength,
              mode: 'pages'
      }"
            :sort-options="{
            enabled: true,
  }">
          <template
              slot="table-row"
              slot-scope="props"
          >
            <div
                v-if="props.column.field === 'title'"
                class="text-nowrap"
            >
              <span class="text-nowrap">{{ props.row.title }}</span>
            </div>
            <div v-else-if="props.column.field === 'type'">
              <span v-if="props.row.object_model==='tour'">
                  تور گردشگری
              </span>
              <span v-if="props.row.object_model==='car'">
               ترانسفر
              </span>
              <span v-if="props.row.object_model==='event'">
                  تفریحات
              </span>
            </div>
            <div v-else-if="props.column.field === 'host'">
              {{ props.row.host_name }}
            </div>
            <div v-else-if="props.column.field === 'guest'">
              {{ props.row.full_name }}
            </div>
            <div v-else-if="props.column.field === 'phone_guest'" style="direction: ltr">
              {{ props.row.phone_guest }}
            </div>
            <div v-else-if="props.column.field === 'total_guest'">
              {{ props.row.total_guests }} نفر
            </div>
            <div v-else-if="props.column.field === 'price'">
              {{ numberFormat(props.row.price) }} تومان
            </div>
            <div class="highlight-blue" v-else-if="props.column.field === 'created_at'">
              {{
                new Date(props.row.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </div>
            <div class="highlight-yellow" v-else-if="props.column.field === 'start_date'">
              {{
                props.row.start_date.split(' ')[0]
              }}
            </div>
            <div v-else-if="props.column.field === 'status'">
                     <span v-if="props.row.payment_status ==='draft'" style="color: red">
                    پرداخت ناموفق
              </span>
              <span v-else-if="props.row.payment_status ==='paid'" style="color: green">
                    پرداخت موفق
              </span>
              <span v-else style="color: #1ab7ea">
                   اومده خرید
              </span>
            </div>
          </template>

        </vue-good-table>



      </b-card>
    </div>
  </div>
</template>

<script>

import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ImageCropper from "@/components/ImageCropper.vue";

export default {
  components: {
    VueGoodTable,
    ImageCropper,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
  },
  data() {
    return {
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'light', 'dark'],

      loading: false,

      pageLength: 20,
      columns: [
        {
          label:  'عنوان',
          field: 'title',
        },
        {
          label: 'نوع',
          field: 'type',
        },
        {
          label: 'میزبان',
          field: 'host',
        },
        {
          label: 'مهمان',
          field: 'guest',
        },
        {
          label: 'شماره مهمان',
          field: 'phone_guest',
        },
        {
          label: 'تعداد',
          field: 'total_guest',
        },
        {
          label: 'هزینه',
          field: 'price',
        },
        {
          label: 'تاریخ درخواست',
          field: 'created_at',
        },
        {
          label: 'تاریخ اجرا',
          field: 'start_date',
        },
        {
          label: 'وضعیت',
          field: 'status',
        },
      ],
      rows: [],


      perPage: 10,
      page: 1,
      booking: null,

      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,


      companies: [],
      companiesCancelToken: undefined,


    };
  },
  mounted() {

     this.getBooking();
  },
  watch: {

  },
  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },



    async getBooking(THIS = this) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // search: this.searchInput,
        // per_page: this.perPage,
        page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
        // host: window.location.href.replace('3000', '8080').replace('8081', '8080'),
      };

      const requestData = {
        headers: {
          "Accept":"application/json",
          "Content-Type": "application/json"
        },
        method: "get",
        url: "/admin/shopping",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            THIS.booking = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>
<style lang="scss">
.vgt-table.bordered td, [dir] .vgt-table.bordered th{
  font-size: 14px !important;
}
.highlight-yellow{
  display: inline-block;
  padding: .25em 0;
  background: yellow;
  color: #222;
}
.highlight-blue{
  display: inline-block;
  padding: .25em 0;
  background: deepskyblue;
  color: #222;
}
</style>
